import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import { t } from "i18next";
import { TextDocumentDto, ViewDocumentAsOwnerDto, ViewSharedDocumentDto } from "../../../../../autogen/bff-api";
import { CounterpartyContext } from "../../../../../common/types";
import { CreateSignedDocument, MainDocumentContext } from "./CreateSignedDocument";

interface Props {
  contractId: string;
  mainDocument: MainDocumentContext;
  documents: (ViewSharedDocumentDto | ViewDocumentAsOwnerDto)[];
  textDocuments?: TextDocumentDto[];
  onClose: () => void;
  counterpartyContext: CounterpartyContext;
}

export const SendForSigningModal = ({
  contractId,
  mainDocument,
  documents,
  textDocuments,
  onClose,
  counterpartyContext,
}: Props) => {
  return (
    <Modal isOpen={true} onClose={onClose} size="3xl">
      <ModalOverlay />
      <ModalContent maxH="85vh">
        <ModalHeader>{t("Send document for signing")}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb="0" overflowY="auto">
          <CreateSignedDocument
            contractId={contractId}
            mainDocument={mainDocument}
            documents={documents}
            textDocuments={textDocuments ?? []}
            counterpartyContext={counterpartyContext}
            onSuccess={onClose}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
